exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".signature-container {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  max-width: 300px;\n  border: 1px solid;\n  background-color: white;\n  border-radius: 4px;\n  height: 150px; }\n  .signature-container .buttons-container {\n    display: flex;\n    justify-content: space-evenly;\n    padding: 2px; }\n    .signature-container .buttons-container .clear-button {\n      width: 45%;\n      height: 32px;\n      color: white;\n      background-color: #a4bf43;\n      font-size: 16px;\n      border: none;\n      border-radius: 5px; }\n    .signature-container .buttons-container .save-button {\n      width: 45%;\n      height: 32px;\n      color: white;\n      background-color: #a4bf43;\n      font-size: 16px;\n      border: none;\n      border-radius: 5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/reusableComponents/SignatureInput/signatureInput.scss
// module id = 2438
// module chunks = 0